module.exports = __webpack_public_path__ + "img/RSD.d0202b9c.svg";